import * as React from "react";
import { Space, Tag, Typography } from "antd";
import type { BreakdownVM } from "../../domain/packageBreakdowns/types";
import { formatPercent } from "../../domain/packageBreakdowns/helpers";

const { Text } = Typography;

export interface BreakdownLegendLineProps {
    x: BreakdownVM;
    color: string;
    truncate?: boolean;
    highlighted?: boolean;
}

const dotStyle = (color: string): React.CSSProperties => ({
    width: 10,
    height: 10,
    borderRadius: 3,
    background: color,
    border: "1px solid rgba(0,0,0,0.10)",
    flex: "0 0 auto",
});

const tagStyle: React.CSSProperties = {
    marginRight: 0,
    background: "#fafafa",
    borderColor: "#f0f0f0",
    color: "rgba(0,0,0,0.65)",
};

export const BreakdownLegendLine: React.FC<BreakdownLegendLineProps> = ({
    x,
    color,
    truncate = true,
    highlighted = false,
}) => (
    <div
        style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 8,
            width: "100%",
            padding: highlighted ? "4px 6px" : 0,
            margin: highlighted ? "-4px -6px" : 0,
            borderRadius: 8,
            background: highlighted ? "rgba(24, 144, 255, 0.08)" : "transparent",
            transition: "background 120ms ease",
        }}
    >
        <Space size={6} style={{ minWidth: 0 }}>
            <span style={dotStyle(color)} />

            <Tag style={tagStyle}>{x.typeName}</Tag>

            <Text
                style={
                    truncate
                        ? { maxWidth: 170 }
                        : { maxWidth: "none", whiteSpace: "normal", wordBreak: "break-word" }
                }
                ellipsis={truncate ? { tooltip: x.productName } : false}
            >
                {x.productName}
            </Text>
        </Space>

        <Text strong>{formatPercent(x.percentage)}</Text>
    </div>
);
